import React from "react";
import { useAuth } from "../../context/AuthContext";
import Layout from "../../components/Layout";
import Unauthorized from "../../components/permisos/Unauthorized";

const ProtectedRoute = ({ children, allowedProfiles, requiredPermission }) => {
  const { user } = useAuth();

  // Caso 1: aún no se resolvió el usuario → loader
  if (user === null) {
    return <div>Cargando sesión...</div>; 
  }

  // Caso 2: usuario sin perfil autorizado
  if (allowedProfiles && !allowedProfiles.includes(user.perfil)) {
    return (
      <Layout>
        <Unauthorized />
      </Layout>
    );
  }

  // Caso 3: usuario sin permiso requerido
  if (requiredPermission && !(user.permissions || []).includes(requiredPermission)) {
    return (
      <Layout>
        <Unauthorized />
      </Layout>
    );
  }

  // Caso 4: usuario válido → renderiza la ruta protegida
  return children;
};

export default ProtectedRoute;


/** import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Layout from "../../components/Layout";
import Unauthorized from "../../components/permisos/Unauthorized";

const ProtectedRoute = ({ children, allowedProfiles, requiredPermission }) => {
  const { user } = useAuth();

  // Si no hay usuario → login
  if (!user) return <Navigate to="/login" replace />;

  // Validar perfil
  if (allowedProfiles && !allowedProfiles.includes(user.perfil)) {
    return (
      <Layout>
        <Unauthorized />
      </Layout>
    );
  }

  // Validar permisos
  if (requiredPermission && !(user.permissions || []).includes(requiredPermission)) {
    return (
      <Layout>
        <Unauthorized />
      </Layout>
    );
  }

  // Usuario válido → renderiza contenido protegido
  return children;
};

export default ProtectedRoute;



/** import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();

  if (!user) {
    // Redirige a login si no hay usuario
    return <Navigate to="/login" replace />;
  }

  // Si hay usuario, renderiza los hijos (la ruta protegida)
  return children;
};

export default ProtectedRoute;
*/